import type { AuthUserPayload } from "@/lib/api/types";
import {
  capturePostHogPageview,
  identifyPostHogUser,
  initPostHog,
  installPostHogClickTracking,
  resetPostHog,
} from "@/lib/analytics/posthog";
import * as React from "react";
import { useLocation } from "react-router-dom";

export function PostHogAnalytics({ connected, user }: { connected: boolean; user: AuthUserPayload | null }) {
  const location = useLocation();
  const identifiedUserId = React.useRef<string | null>(null);
  const wasConnected = React.useRef(false);

  React.useEffect(() => {
    initPostHog();
    return installPostHogClickTracking();
  }, []);

  React.useEffect(() => {
    void capturePostHogPageview();
  }, [location.pathname, location.search, location.hash]);

  React.useEffect(() => {
    if (connected && user?.id) {
      wasConnected.current = true;

      if (identifiedUserId.current !== user.id) {
        identifiedUserId.current = user.id;
        void identifyPostHogUser(user);
      }

      return;
    }

    identifiedUserId.current = null;

    if (wasConnected.current) {
      wasConnected.current = false;
      void resetPostHog();
    }
  }, [connected, user]);

  return null;
}
